import Mobile3Months from '../../../images/3-miesiace-bezpromo_mobile.svg';
import Mobile3MonthsPromo from '../../../images/3-miesiac-zpromo_mobile.svg';
import Mobile1MonthPromo from '../../../images/1-miesiac-zpromo_mobile.svg';
import Mobile1Month from '../../../images/1-miesiac-bezpromo_mobile.svg';
import Mobile6MonthPromo from '../../../images/6-miesiecy-zpromo_mobile.svg';
import Mobile6Month from '../../../images/6-miesiecy-bezpromo_mobile.svg';

export const BANNER_CONFIG = {
	basic: {
		promo: Mobile1MonthPromo,
		normal: Mobile1Month,
	},
	pro: {
		promo: Mobile3MonthsPromo,
		normal: Mobile3Months,
	},
	premium: {
		promo: Mobile6MonthPromo,
		normal: Mobile6Month,
	},
};
